import React, { useState } from 'react';
import RegistroPrestadoresView from './RegistroPrestadoresView';
import { useHistory } from 'react-router-dom';
import { useFormik } from "formik";
import { registroSchema } from './registro.schema';
import { UseRegistroPrestador } from '../../../services/Registro';

const RegistroPrestadores = () => {

    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({
        state: false,
        message: ""
    });

    const [terminos_y_condiciones, acepto_terminos_y_condiciones] = useState(false);

    const [zonas] = useState([
        { name: "Santa Rosa" },
        { name: "General Pico" },
        { name: "Toay" },
        { name: "Realicó" },
        { name: "Macachín" },
        { name: "Victorica" },
        { name: "Colonia 25 de Mayo" },
        { name: "Intendente Alvear" },
        { name: "Eduardo Castex" },
        { name: "General Acha" },

    ]);
    const [servicios] = useState([
        { name: "Mecánico" },
        { name: "Lavandero" },
        { name: "Artesano" },
        { name: "Carpintero" },
        { name: "Escultor" },
        { name: "Albañil" },
        { name: "Editor" },
        { name: "Barrendero" },
        { name: "Plomero" },
        { name: "Obrero" },

    ]);

    const validacion_de_prestador = async (nombre, apellido, dni, email, password, codigo_de_area, celular, zonas, servicios, terminos_y_condiciones) => {
        UseRegistroPrestador(nombre, apellido, dni, email, password, codigo_de_area, celular, zonas, servicios, terminos_y_condiciones)
    };

    const formik = useFormik({
        initialValues: {
            nombre: "",
            apellido: "",
            dni: "",
            email: "",
            password: "",
            confirmar_password: "",
            codigo_de_area: "",
            celular: "",
            zonas: [],
            servicios: [],
        },

        validationSchema: registroSchema,

        onSubmit: async (values) => {

            if (values.password === values.confirmar_password) {
                const prestador_valido = await validacion_de_prestador(
                    formik.values.nombre,
                    formik.values.apellido,
                    formik.values.dni,
                    formik.values.email,
                    formik.values.password,
                    formik.values.codigo_de_area,
                    formik.values.celular,
                    formik.values.zonas,
                    formik.values.servicios,
                    terminos_y_condiciones,
                )
                /*  history.push("/mi-perfil") */
                console.log(prestador_valido)
            }

        }

    })


    return (

        <RegistroPrestadoresView
            formik={formik}
            loading={loading}
            error={error}
            terminos_y_condiciones={terminos_y_condiciones}
            acepto_terminos_y_condiciones={acepto_terminos_y_condiciones}
            servicios={servicios}
            zonas={zonas}

        />


    )
}

export default RegistroPrestadores
